const delay = (ms) => new Promise((res) => setTimeout(res, ms));
export const transitionToView = async (newView, contextData, options) => {
    const { setContentVisible, setCurrentView, setCallOutcomesContext, setCallFinderContext, setExecutiveContext, setResponseMetricsContext, restoreScrollPosition, } = options;
    setContentVisible(false);
    await delay(500);
    setCurrentView(newView);
    if (newView === "call-outcomes" && contextData) {
        setCallOutcomesContext(contextData);
    }
    else if (newView === "call-finder" && contextData) {
        setCallFinderContext(contextData);
    }
    else if (newView === "executive-summary" && contextData) {
        setExecutiveContext(contextData);
    }
    else if (newView === "response-metrics" && contextData) {
        setResponseMetricsContext(contextData);
    }
    else if (newView === "dashboard") {
        setCallOutcomesContext(null);
        setCallFinderContext(null);
        setExecutiveContext(null);
        setResponseMetricsContext(null);
    }
    await delay(100);
    if (newView === "dashboard") {
        restoreScrollPosition();
    }
    else {
        window.scrollTo({ top: 0, behavior: "instant" });
        setContentVisible(true);
    }
};
export const showPresetsWithTransition = (options) => {
    const { presetsVisible, setDashboardVisible, setPresetsVisible } = options;
    if (!presetsVisible) {
        setDashboardVisible(false);
        setTimeout(() => {
            setTimeout(() => setPresetsVisible(true), 50);
        }, 300);
    }
};
export const hidePresetsWithTransition = (options) => {
    const { presetsVisible, setPresetsVisible, setDashboardVisible } = options;
    if (presetsVisible) {
        setPresetsVisible(false);
        setTimeout(() => {
            setTimeout(() => setDashboardVisible(true), 50);
        }, 300);
    }
};
//# sourceMappingURL=transitionUtils.js.map